// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KEL4","question":"styles_question__yssBh","description":"styles_description__1TCIw"};